export default function isBusy(state = false, action) {
  if (action.type === 'ON_BUSY') {
    return true;
  } else if (action.type === 'OFF_BUSY') {
    return false;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/requestStatus.js
 **/